import { render, staticRenderFns } from "./SiestaTotal.vue?vue&type=template&id=533f7784&scoped=true&"
import script from "./SiestaTotal.vue?vue&type=script&lang=js&"
export * from "./SiestaTotal.vue?vue&type=script&lang=js&"
import style0 from "./SiestaTotal.vue?vue&type=style&index=0&id=533f7784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533f7784",
  null
  
)

export default component.exports